const cardRoutes = {
    path: '/card',
    name: 'Card Management',
    roles: ['Admin'],
    icon: 'dripicons-card',
    children: [
        {
            path: '/card/view',
            name: 'EDGE Cards',
        },

        {
            path: '/card/transactions',
            name: 'Card Transactions',
        },
    ],
};
// const depositRoutes = {
//     path: '/deposit',
//     name: 'Deposit Funds',
//     roles: ['Admin'],
//     icon: 'dripicons-card',
//     children: [
//         {
//             path: '/deposit/bank_deposit',
//             name: 'Bank Deposit',
//         },

//         {
//             path: '/deposit/card_deposit',
//             name: 'Card Deposit',
//         },
//     ],
// };

const depositRoutes = {
    name: 'Deposit Funds',
    roles: ['Admin'],
    icon: 'dripicons-card',
    path: '/deposit/bank_deposit',
};

const responsibleBettingAppRoutes = {
    path: '/betting',
    name: 'Responsible Gaming',
    roles: ['Admin'],
    icon: 'dripicons-briefcase',
    children: [
        {
            path: '/betting/tips',
            name: 'Responsible Gaming Tips',
        },
        {
            path: '/betting/notification',
            name: 'Email Notifications',
        },
        {
            path: '/betting/manage-limits',
            name: 'Manage Limits',
        },
        {
            path: '/betting/cooldown',
            name: 'Cooldown',
        },

        {
            path: '/betting/help',
            name: 'Get Help',
        },
    ],
};

const tutorialAppRoutes = {
    name: 'Account Setup Guide',
    roles: [],
    icon: 'dripicons-article',
    path: '/tutorials/setup',
};

const legalAppRoutes = {
    path: '/legal',
    name: 'Legal Documents',
    roles: [],
    icon: 'dripicons-information',
    path: '/legal/documents',
};
const appRoutes = [
    depositRoutes,

    {
        path: '/funds/withdraw',
        name: 'Withdraw Funds',
        icon: 'dripicons-upload',
    },
    {
        path: '/bank/accounts',
        name: 'Manage Bank Accounts',
        icon: 'dripicons-wallet',
    },
    cardRoutes,
    responsibleBettingAppRoutes,
    tutorialAppRoutes,
    legalAppRoutes,
];

const authProtectedRoutes = [...appRoutes];

export default authProtectedRoutes;
